
import * as SessionAPI from "@/services/api/sessions";

export class SessionManager {

	constructor(sessionId:string){
		this._session = sessionId;
	}

	public setNodeChannels(nodeId:string, data:any){
		this._nodeData[nodeId] = data;
	}
	
	public getNodeKey(nodeId:string){
		this._nodeData[nodeId] ? JSON.parse(JSON.stringify(this._nodeData[nodeId])) : null;
	}

	public getData(){
		return this._nodeData;
	}

	public async saveNodeChannels(nodeId:string){
		if(!this._session){
			console.info("Session Manager: Session ID not set; data won't be saved to backend.");
			return;
		}
		const node = this._nodeData[nodeId];
		if(!node){ return; }
		const payload = Object.keys(node)
		.map(k => { return { key: k, data:node[k] } });
		
		console.log("SAVE CHANNELS");

		return await SessionAPI.saveDataChannels(this._session, payload);
	}

	private _session:string;
	private _nodeData:any = {};
}